import {
  Box,
  Grid,
  GridProps,
  Typography
} from "@mui/material";

import { styled } from "@mui/material/styles";


export const CardProfileBox = styled(Grid)<GridProps>(({ theme }) => ({
  "& p, h1, svg, path, span": {
    color: theme.customColors.exploreCardText
  },
  "&:hover": {
    border: `2px solid ${theme.customColors.borderAccent}`
  },
  background: theme.customColors.backgroundCard,
  border: `2px solid  ${theme.customColors.border}`,
  borderRadius: "1.125rem",
  color: theme.customColors.exploreCardText,
  display: "flex",
  flexDirection: "column",
  gap: "1.5rem",
  padding:theme.spacing(3),
  width:"24rem",
  [theme.breakpoints.down("sm")]:{
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    padding:theme.spacing(2),
    width:"100%"
  }

})) as typeof Grid; // monkeypatch to fix property 'component' does not exist on type 'intrinsicattributes'

export const Description= styled(Box)(({ theme }) => ({
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "0.5rem",
  "a":{
    display:"flex",
    fontWeight:700
  },
  "h5":{
    fontSize:theme.spacing(4),
    paddingBottom:theme.spacing(1)
  },
  "p":{
    paddingBottom:theme.spacing(1)
  },
  [theme.breakpoints.down("sm")]:{
    "a":{
      fontSize: "0.75rem",
      lineHeight: "0.875rem"
    },

    display: "flex",
    flexDirection: "column",

    "h5":{
      fontSize:theme.spacing(2),
      lineHeight: "1.3125rem",
      paddingBottom: "6px"
    },
    "p":{
      fontSize: "12px",
      lineHeight: "0.875rem",
      paddingBottom:theme.spacing(0.6) }
  }

}));

export const ContentBox = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(3),
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  [theme.breakpoints.down("sm")]:{
    gap: "15px",
    height: "100%"
  }
}));

export const TitleTypography = styled(Typography)(({ theme }) => ({
  color: theme.customColors.textWidget,
  fontSize:"1.25rem",
  fontWeight: 700,
  lineHeight: "1.5rem",
  padding: "0 !important"
}));

export const InfoTypography = styled(Typography)(({ theme }) => ({
  color: theme.customColors.textWidget,
  fontSize:"0.75rem",
  fontWeight: 400,
  lineHeight: "1rem",
  padding: "0 !important"
}));

export const AuthWrapper= styled(Box)(() => ({
  "& > a": {
    fontSize: "12px",
    fontWeight: 600,
    lineHeight: "100%",
    whiteSpace: "nowrap"
  },
  alignItems: "center",
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center"
}));
